<script>
  import { activeMatch, currentScreen, fullScreenBoard, modalState, peerRole } from '../store.js';
  import { startSecondInnings, setOpeners, formatOvers } from '../../scoring-logic.js';
  import { persist } from '../../store.js';
  import { toast } from '../../ui/dialogs.js';
  import { liveScreenForDevice } from '../../device-session.js';

  if (!$activeMatch) {
    currentScreen.set('home');
  }

  let s = { striker: "", nonStriker: "", bowler: "" };

  $: inn1 = $activeMatch?.innings[0];
  $: inn2 = $activeMatch?.innings[1] || null;
  $: nextBattingTeam = inn1?.battingTeam === 'A' ? 'B' : 'A';
  
  $: battingTeam = $activeMatch ? (nextBattingTeam === 'A' ? $activeMatch.teamA : $activeMatch.teamB) : null;
  $: bowlingTeam = $activeMatch ? (nextBattingTeam === 'A' ? $activeMatch.teamB : $activeMatch.teamA) : null;
  $: team1Name = inn1 ? (inn1.battingTeam === 'A' ? $activeMatch.teamA.name : $activeMatch.teamB.name) : "";
  // 1v1 challenge (e.g. Super Over): the batting side has a single player —
  // there is no non-striker to pick, they bat alone (last-man-stands style).
  $: soloBatting = battingTeam ? battingTeam.players.length < 2 : false;
  $: if (soloBatting && battingTeam) { s.striker = battingTeam.players[0]; s.nonStriker = ""; }
  $: if (bowlingTeam && bowlingTeam.players.length === 1) { s.bowler = bowlingTeam.players[0]; }

  function startInnings() {
    if (!s.striker || (!s.nonStriker && !soloBatting) || !s.bowler) { toast("Pick striker, non-striker and bowler first.", "error"); return; }
    if (!soloBatting && s.striker === s.nonStriker) { toast("Striker and non-striker must be different.", "error"); return; }
    if ($activeMatch.innings.length < 2) startSecondInnings($activeMatch);
    setOpeners($activeMatch, s.striker, soloBatting ? null : s.nonStriker, s.bowler);
    activeMatch.update(m => m); // Trigger reactivity
    
    // Clear stuck innings break UI on recorder
    fullScreenBoard.set(null);
    modalState.set(null);

    // persist() calls _peerSyncState() internally, so no separate call needed
    persist();
    currentScreen.set(liveScreenForDevice($activeMatch, $peerRole));
  }
</script>

{#if $activeMatch && inn1 && battingTeam && bowlingTeam}
  <div class="screen">
    <h1>Innings Break</h1>
    <div class="card">
      <div style="font-size:18px;font-weight:800">{team1Name}: {inn1.totalRuns}/{inn1.wickets} ({formatOvers(inn1.balls)})</div>
      <div class="muted" style="margin-top:6px">Target for {battingTeam.name}: {inn1.totalRuns + 1}</div>
    </div>

    <div class="card">
      <div style="font-weight:800;margin-bottom:6px">{battingTeam.name} openers</div>
      
      <div class="field">
        <label for="second-innings-striker">Striker</label>
        <select id="second-innings-striker" bind:value={s.striker}>
          <option value="">Select striker</option>
          {#each battingTeam.players.filter(p => p !== s.nonStriker) as o (o)}
            <option value={o}>{o}</option>
          {/each}
        </select>
      </div>

      {#if !soloBatting}
        <div class="field">
          <label for="second-innings-non-striker">Non-striker</label>
          <select id="second-innings-non-striker" bind:value={s.nonStriker}>
            <option value="">Select non-striker</option>
            {#each battingTeam.players.filter(p => p !== s.striker) as o (o)}
              <option value={o}>{o}</option>
            {/each}
          </select>
        </div>
      {:else}
        <div class="muted" style="font-size:12px; margin:6px 0;">🛡 Solo batter — {s.striker} bats alone (last man stands).</div>
      {/if}

      <div class="field">
        <label for="second-innings-bowler">Opening bowler</label>
        <select id="second-innings-bowler" bind:value={s.bowler}>
          <option value="">Select bowler</option>
          {#each bowlingTeam.players as o (o)}
            <option value={o}>{o}</option>
          {/each}
        </select>
      </div>
    </div>

    <button class="btn btn-primary btn-block" on:click={startInnings}>
      START 2ND INNINGS ▶
    </button>
  </div>
{/if}
